<template>
  <app-dialog @close="$emit('close')">
    <template #title>
      Choose Instrument
    </template>
    <v-row no-gutters justify="center" align="center" class="pb-4 px-3">
      <v-col :cols="12">
        <v-radio-group row dense hide-details
                       class="justify-center text-capitalize"
                       v-model="type">
          <v-radio color="primary"
                   v-for="(name, i) in Object.keys(types)"
                   :key="i"
                   :label="name"
                   :value="i"/>
        </v-radio-group>
      </v-col>
      <v-col :cols="12">
        <v-row dense justify="center" align="center">
          <v-col :cols="6" v-for="ins in Object.values(types)[type]" :key="ins">
            <v-btn small block class="ma-1"
                   @click="update(ins)"
                   :outlined="getPlayerInstrument(player)!==ins"
                   :color="getPlayerInstrument(player)!==ins ? '':'success'">
              <span class="text-capitalize">
                {{ ins }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
        <!--                <v-col :cols="12">-->
        <!--                  <v-divider class="pb-2"/>-->
        <!--                </v-col>-->
        <!--                <v-col :cols="12" v-if="tab">-->
        <!--                  Type:-->
        <!--                  <v-menu offset-y>-->
        <!--                    <template #activator="{ on }">-->
        <!--                      <v-btn-->
        <!--                          color="primary"-->
        <!--                          dark-->
        <!--                          v-on="on"-->
        <!--                      >-->
        <!--                        {{oscType}}-->
        <!--                      </v-btn>-->
        <!--                    </template>-->
        <!--                    <v-list>-->
        <!--                      <v-list-item-->
        <!--                          v-for="item in types"-->
        <!--                          :key="item"-->
        <!--                          @click=""-->
        <!--                      >-->
        <!--                        <v-list-item-title>{{ item }}</v-list-item-title>-->
        <!--                      </v-list-item>-->
        <!--                    </v-list>-->
        <!--                  </v-menu>-->
        <!--                </v-col>-->
      </v-col>
    </v-row>
    <div class="text-center">
      <v-btn block class="text-capitalize"
             color="success"
             @click="playNotes({notes: [`${getPitch}${getOctave}`], player})">
        {{ `${getPitch}${getOctave}` }}
        <app-icon icon="play-arrow"/>
      </v-btn>
    </div>
  </app-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { instruments, synths }    from 'misc/Constants'
  import UsageCounters              from 'reporting/UsageCounters'

  export default {
    name: 'SelectInstrument',

    components: {
      AppDialog: () => import(/* webpackChunkName: "app-main" */ 'components/AppDialog'),
    },

    props: {
      player: { default: 0 },
    },

    data() {
      return {
        type:  0,
        types: { instruments, synths },
        // types: ['sine', 'triangle', 'square', 'sawtooth'],
      }
    },

    computed: {
      ...mapGetters('context', ['getOctave', 'getPitch']),
      ...mapGetters('transport', ['getPlayerInstrument']),

      // oscType: function () {
      //   return this.lead.handler ? this.lead.handler.get('oscillator').oscillator.type : 'sine'
      // },
    },

    methods: {
      ...mapActions('transport', ['setPlayerInstrument', 'playNotes']),
      async update(value) {
        ++UsageCounters.times_changed_instrument
        this.setPlayerInstrument({ playerName: this.player, value })
      },
    },
  }
</script>
